import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

// Components
import RawHtml from '../RawHtml';

export const TitleText = ({ title, children }) => (
  <div className={css`${titleTextWrapper}`}>
    {title && (
      <p className='title'>
        <strong>{title}</strong>
      </p>
    )}
    {children && <RawHtml>{children}</RawHtml>}
  </div>
);

TitleText.propTypes = {
  title: PropTypes.string,
  children: PropTypes.string
};

export default TitleText;

/**
 * CSS
 */
const titleTextWrapper = `
  .title {
    color: #3e4b69;
    word-wrap: break-word;
    margin-bottom: 8px;

    strong {
      font-weight: 600;
    }
  }

  > div {
    word-wrap: break-word;
    font-weight: 400;

    a {
      color: #1abc9c;
    }
  }
`;
